import { NotificationRegistry } from '@neos/core'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets EntitiesSaving.
   */
  entitiesSaving = this.create<boolean, void>('EntitiesSaving')
}